var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.095,
    height: 25.88,
    viewBox: "0 0 35.095 25.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet-filled-commercial-tool",
    transform: "translate(0 -129.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4744",
    d: "M2.136 155.33H30.6a2.137 2.137 0 0 0 2.136-2.136v-4.819H22.52a5.693 5.693 0 0 1-5.236-3.47 5.684 5.684 0 0 1-.448-2.214v-.6a5.693 5.693 0 0 1 3.47-5.236 5.684 5.684 0 0 1 2.214-.448h10.219v-4.819a2.137 2.137 0 0 0-2.139-2.138H2.136A2.137 2.137 0 0 0 0 131.586v21.609a2.137 2.137 0 0 0 2.136 2.135z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4745",
    d: "M549.124 386.452a1.6 1.6 0 0 0-1.6-1.6h-10.975A3.547 3.547 0 0 0 533 388.4v.6a3.547 3.547 0 0 0 3.549 3.549h10.973a1.6 1.6 0 0 0 1.6-1.6zm-11.995 4.132a1.886 1.886 0 1 1 1.886-1.886 1.885 1.885 0 0 1-1.886 1.886z",
    fill: "currentColor",
    transform: "translate(-514.029 -246.309)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.2486f7d9.svg";
export { ForwardRef as ReactComponent };